import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { convertQueryParamsToString } from 'modules/messagingInsights/utils';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PAGE_SIZES } from 'ui/paginationFooter';
import { CREATOR_FILTER_TABS } from '../constants';
import { fetchViewsRequest } from '../redux/actions';
import { QueryContext } from './QueryContext';

export const QueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const dispatch = useDispatch();
  const [creatorFilter, setCreatorFilter] = useState(CREATOR_FILTER_TABS[0].id);
  const [searchTerm, setSearchTerm] = useState('');
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('updatedAt');
  const [sortDirection, setSortDirection] = useState(SORT_DIRECTIONS.DESCENDING);
  const [refetchViews, setRefetchViews] = useState(false);

  const toggleRefetchViews = () => {
    setRefetchViews(!refetchViews);
  };

  useEffect(() => {
    const queryString = convertQueryParamsToString({
      pageSize,
      page: currentPage,
      searchString: searchTerm,
      sortBy,
      sortDirection: sortDirection === SORT_DIRECTIONS.ASCENDING ? 'asc' : 'desc',
      creatorOnly: creatorFilter === 'created-by-me',
    });
    dispatch(fetchViewsRequest(queryString));
  }, [pageSize, currentPage, searchTerm, sortBy, sortDirection, creatorFilter, refetchViews]);

  return (
    <QueryContext.Provider
      value={{
        creatorFilter,
        setCreatorFilter,
        searchTerm,
        setSearchTerm,
        pageSize,
        setPageSize,
        currentPage,
        setCurrentPage,
        sortBy,
        setSortBy,
        sortDirection,
        setSortDirection,
        refetchViews,
        toggleRefetchViews,
      }}
    >
      {children}
    </QueryContext.Provider>
  );
};
